var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayAreaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.25,
    height: 93.24,
    fill: "#104864"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-401 -1694.998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 97.5,
    r: 97.5,
    transform: "translate(401 1694.998)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(457 1745.998)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.249,76.334a1.265,1.265,0,0,0-1.265-1.265H83.416l-9.248-20.55A18.22,18.22,0,0,0,57.574,43.786h-8.12V24.419h1.863a1.265,1.265,0,0,0,.832-2.218L27.124.3a1.3,1.3,0,0,0-1.665,0L.432,22.2a1.265,1.265,0,0,0,.833,2.218H3.128V91.975a1.258,1.258,0,0,0,.37.895,1.278,1.278,0,0,0,.895.37H10.65a1.28,1.28,0,0,0,.895-.37,1.261,1.261,0,0,0,.37-.895V61.958h3.726V91.975a1.26,1.26,0,0,0,.371.895,1.275,1.275,0,0,0,.894.37h6.257a1.265,1.265,0,0,0,1.265-1.265V86.983h3.726v4.991a1.266,1.266,0,0,0,1.266,1.265h6.256a1.273,1.273,0,0,0,.894-.37,1.257,1.257,0,0,0,.371-.895V61.958h3.726V91.975a1.258,1.258,0,0,0,.37.895,1.278,1.278,0,0,0,.895.37h6.256a1.28,1.28,0,0,0,.895-.37,1.261,1.261,0,0,0,.37-.895V61.958h7.3L66,82.508A18.223,18.223,0,0,0,82.6,93.24h9.385a1.259,1.259,0,0,0,.895-.37,1.277,1.277,0,0,0,.37-.895ZM9.384,90.71H5.659V24.419H9.384Zm12.513,0H18.172V86.985H21.9Zm12.513,0H30.685V86.985H34.41Zm0-6.256H18.171V80.728H34.41ZM18.171,74.471H21.9V78.2H18.171Zm6.257,0h3.726V78.2H24.428ZM34.41,78.2H30.685V74.471H34.41Zm0-6.256H18.171V68.215H34.41ZM18.171,61.958H21.9v3.726H18.171Zm6.257,0h3.726v3.726H24.428Zm9.982,3.726H30.685V61.958H34.41Zm6.257-6.256H11.916V55.7H40.667Zm-22.5-6.256V38.795a8.12,8.12,0,0,1,16.239,0V53.171Zm22.5,0H36.941V38.795a10.65,10.65,0,0,0-21.3,0V53.171H11.916V24.419H40.667ZM46.923,90.71H43.2V24.419h3.725ZM4.632,21.888,26.291,2.938l21.66,18.95ZM90.719,90.71H82.6a15.673,15.673,0,0,1-14.287-9.239l-9.584-21.3a1.268,1.268,0,0,0-1.154-.746h-8.12V55.7h8.12a4.991,4.991,0,0,1,4.551,2.943L72.052,80.7a10.664,10.664,0,0,0,9.714,6.285h8.954Zm0-6.257H81.765a8.13,8.13,0,0,1-7.405-4.787L64.433,57.611a7.537,7.537,0,0,0-6.86-4.441H49.454V46.316h8.12A15.692,15.692,0,0,1,71.86,55.555l9.585,21.3A1.265,1.265,0,0,0,82.6,77.6h8.12Z",
    transform: "translate(0 0)",
    fill: "#104864"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayAreaIcon);
export default __webpack_public_path__ + "static/media/PlayAreaIcon.d7b47a30be002198be59502145a84557.svg";
export { ForwardRef as ReactComponent };